define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/action/FormData",
	"csi/locale",
	"csi/reflection",
	"csi/wizard/ActionControllerMixin",
	"csi/xml"
], function (declare, lang, Controller, FormData, locale, reflection, ActionControllerMixin, xml) {

	var IMAGE_SELECT_PAGE = 0;
	var STYLE_SELECT_PAGE = 1;
	var HIERARCHY = ["Style", "Collection", "Category2", "Category1", "ParentSeason"];

	return declare([Controller, ActionControllerMixin], {
		successMsg: "",

		/** @property {FormData} fdImages - FormData for the first page - select images  */
		fdImages: null,

		onWizardViewPreCreate: function (/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			// summary: notify when view definition for page is found and ready for creation with ability to add own viewParams
			var index = wizard.getIndexOfPage(page);
			if (index == IMAGE_SELECT_PAGE) {
				viewParams["imageSize"] = reflection.IMAGE_SIZE_SMALLEST;
			}
		},

		onNextPage: function (/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			let fd = this.m_formData;

			if (wizard.getIndexOfPage(nextPage) == 0) {
				fd = this.fdImages = new FormData(this);
				fd.m_bRequireOne = true;
			}

			fd.setNode(null);
			return bFinish ? null : wizard.setFormDataToPage(nextPage, fd, (wizard.getIndexOfPage(nextPage) == 1));
		},

		getFormData: function () {
			// summary: make sure that at least one Style and Image is selected and require edit rights on the styles
			var fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateStyle);
			return fd;
		},

		_canAggregateStyle: function (/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of nodes with admin access
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_ADMIN);
		},

		getSuccess: function () {
			return this.successMsg;
		},

		toWriterRequest: function () {
			var call = this.inherited(arguments);

			const selectedImages = this.fdImages.getSelectedValue();
			const selectedStyles = this.m_formData.getSelectedValue();

			var image_s = (selectedImages.length == 1) ? locale.type("Image") : locale.typePlural("Image");
			var style_s = (selectedStyles.length == 1) ? locale.type("Style") : locale.typePlural("Style");
			this.successMsg = locale.resource("PushImagesToStyles_Success", [selectedImages.length, image_s, selectedStyles.length, style_s]);

			call.addParameter("ParentURL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("Images", xml.ATTR_REFLIST, selectedImages);
			call.addParameter("TargetStyles", xml.ATTR_REFLIST, selectedStyles);
			return call;
		},

		postProcessSuccess: function () {
			this.widget.refreshData();
		}

	});
});
